const initialState = {
  data: null,
};

const SET_ADVISOR_TYPE = 'SET_ADVISOR_TYPE';

export const setAdvisorTypes = (payload) => ({
  type: SET_ADVISOR_TYPE,
  payload,
});

export default function advisorTypesReducer(state = initialState, action) {
  switch (action.type) {
    case SET_ADVISOR_TYPE:
      return { ...state, data: action.payload.data.data };
      default:
      return state;
  }
}
